

// material
import { MenuItem, TextField } from '@mui/material';
// redux
import { useSelector } from 'react-redux';
import { RootState, useDispatch } from '../../redux/store';
import { setCurrentPlace } from '../../redux/slice/place';
// types
import { PlaceData } from '../../@types/_place'
// ----------------------------------------------------------------------

export default function SelectPlaceBar() {
    const dispatch = useDispatch();
    const { currentPlace, places } = useSelector((state: RootState) => state.placeData);

    if (currentPlace == null || places == null) {
        return <div />
    }

    const onSelect = (event: any) => {
        const id = event.target.value
        const selected = places.find((element: PlaceData) => {
            return element.name === id;
        })
        dispatch(setCurrentPlace(selected));
    };

    return (
        <TextField select size="small" value={currentPlace.name} onChange={onSelect}>
            {places.map((option: PlaceData) => (
                <MenuItem key={option.id} value={option.name}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
}